// 常量定义
var PACDORA_CONFIG = {
  MOBILE_BREAKPOINT: 980,
  MAX_RETRIES: 3,
  MESSAGE_DURATION: 2000,
  SLIDER_ANIMATION_DURATION: 1000
}

// --------------------------------------------------------------------------------
// 1. CONFIGURE YOUR COUPONS HERE
// --------------------------------------------------------------------------------
// Format: 'CODE': Value
// - If Value < 1 (e.g., 0.15), it is a PERCENTAGE (15% off).
// - If Value >= 1 (e.g., 50), it is a FLAT AMOUNT ($50 off the TOTAL order).
const VALID_DISCOUNTS = {
  'EZTeam40': 0.40,   // 40% Off
  'ezstart15': 0.15, // 15% Off
  'gift36': 0.36,      // 36% 0ff
  'ezback35' : 0.35, //35%
  'beetlebubs35': 0.35,          // 35% Off
  'ezship250': 250, // $250 Off the Total (distributed across items)
  'pickup250': 250, // $250 Off the Total (distributed across items
  'sub15' : 0.15, // 15% off -subscriber,
  'ezfestive30' : 0.30, // 30% off -subscriber,
  'sharktank26': 0.26 // 
            
};
// --------------------------------------------------------------------------------

// 状态管理
var Pacdora_isMobile = window.innerWidth < PACDORA_CONFIG.MOBILE_BREAKPOINT
var currentModelOrTemplate = null
var lastVariant = null

// 工具函数
var pacdoraUtils = {
  safeQuerySelector: function (selector, parent) {
    parent = parent || document
    try {
      return parent.querySelector(selector)
    } catch (error) {
      console.warn('Invalid selector: ' + selector, error)
      return null
    }
  },
  safeQuerySelectorAll: function (selector, parent) {
    parent = parent || document
    try {
      return Array.from(parent.querySelectorAll(selector))
    } catch (error) {
      console.warn('Invalid selector: ' + selector, error)
      return []
    }
  },
  getEventPath: function (event) {
    return (event.composedPath && event.composedPath()) || event.path || []
  },
  debounce: function (func, wait) {
    var timeout
    return function () {
      var args = arguments
      var context = this
      var later = function () {
        clearTimeout(timeout)
        func.apply(context, args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  },
  safeJsonParse: function (str, defaultValue) {
    defaultValue = defaultValue || null
    try {
      return JSON.parse(str)
    } catch (error) {
      console.warn('JSON parse error:', error)
      return defaultValue
    }
  }
}

var createPacdora3d = () => {
  const imgs = pacdoraUtils.safeQuerySelectorAll('img')
  const matchedElement = imgs.find((el) =>
    el.src.match(/.*\.ezpac\.3d.*/)
  )
  if (matchedElement) {
    window.addEventListener('click', (e) => {
        if (e.isTrusted === false) return
        const path = pacdoraUtils.getEventPath(e)
        const openBtn = path.find((item) => item.className === 'pacdora-open')
        if (openBtn) {
          e.stopPropagation()
          openPacdora(0)
          return
        }
        const closeBtn = path.find((item) => item.className === 'pacdora-close')
        if (closeBtn) {
          e.stopPropagation()
          openPacdora(1)
          return
        }
        const pacdoraContainer = path.find((item) =>
            item.className && (item.className.includes('pacdora-container') ||
              item.className.includes('pacdora-box'))
        )
        if (pacdoraContainer) {
          e.stopPropagation()
        }
        const switchContainer = path.find((item) =>
          item.className && item.className.includes('pacdora-switch-item')
        )
        if (switchContainer) {
          const switchItem = e.target
          let type = switchItem.dataset.type
          if (!type) {
            let parentElement = switchItem.parentElement
            while (parentElement && !type) {
              type = parentElement.dataset.type
              if (parentElement.className && parentElement.className.includes('pacdora-switch-item')) {
                break
              }
              parentElement = parentElement.parentElement
            }
          }
          onSwitch2DAnd3D(type)
        }
      }, true)
    window.addEventListener('mousedown', (e) => {
        const path = pacdoraUtils.getEventPath(e)
        const pacdoraContainer = path?.find((item) =>
          item.className && item.className.includes('pacdora-box-info')
        )
        if (pacdoraContainer) {
          e.stopPropagation()
        }
      }, true)
    const div = document.createElement('div')
    Object.assign(div.style, { width: '100%', height: '100%' })
    div.className = 'pacdora-box-info'
    const loadingDiv = document.createElement('div')
    loadingDiv.className = 'pacdora-box-loading'
    div.appendChild(loadingDiv)
    const D3ContainerDiv = document.createElement('div')
    D3ContainerDiv.className = 'pacdora-box-info-slider'
    const firstDiv = document.createElement('div')
    firstDiv.className = 'pacdora-box-info-item'
    const switchDiv = document.createElement('div')
    switchDiv.className = 'pacdora-d3-and-d2-switch'
    switchDiv.innerHTML = `
        <div class="pacdora-switch-item active" data-type="3d">3D</div>
        <div class="pacdora-switch-item" data-type="dieline">Dieline</div>
      `;
    const switchItems = switchDiv.querySelectorAll('.pacdora-switch-item')
    switchItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        const type = e.target.dataset.type
        onSwitch2DAnd3D(type, e)
      })
    })
    const controlDiv = document.createElement('div')
    controlDiv.className = 'pacdora-collapse-control'
    controlDiv.setAttribute('data-position', 'bottom')
    controlDiv.style.display = 'none'
    controlDiv.innerHTML = `
        <div class="pacdora-open">Open</div>
        <div class="pacdora-slider-box">
          <div class="pacdora-slider-line" onpointerdown="onSetSlider(event)"></div>
          <div class="pacdora-slider-selecter" onpointerdown="onSetSlider(event)"></div>
          <div class="pacdora-pointer" onpointerdown="onSliderDown(this)"></div>
        </div>
        <div class="pacdora-close">Close</div>
      `
    matchedElement.parentNode?.insertBefore(div, matchedElement)
    matchedElement.style.display = 'none'
    const d3Div = document.createElement('div')
    d3Div.className = 'd3'
    d3Div.dataset.pacdoraUi = '3d'
    d3Div.dataset.pacdoraId = 'd3'
    firstDiv.appendChild(controlDiv)
    firstDiv.appendChild(d3Div)
    const dielineDiv = document.createElement('div')
    dielineDiv.className = 'dieline'
    dielineDiv.dataset.pacdoraUi = 'dieline'
    dielineDiv.dataset.notUseScience = true
    const secondDiv = document.createElement('div')
    secondDiv.className = 'pacdora-box-info-item'
    secondDiv.appendChild(dielineDiv)
    D3ContainerDiv.appendChild(firstDiv)
    D3ContainerDiv.appendChild(secondDiv)
    div.appendChild(D3ContainerDiv)
    div.appendChild(switchDiv)
  }
}

async function interceptCart() {
  if (!window.originalFetch && window.fetch) {
    window.originalFetch = window.fetch
    window.fetch = async function (url, options) {
      if (typeof url === 'string' && url.includes('/cart/add') && options && options.body) {
        let pacdoraObj = { projectId: undefined, image3D: '' }
        try {
          if (window.Pacdora) {
            await Pacdora._waitProjectCreate()
            let { id, screenshot } = await Pacdora.getBoxInfo()
            pacdoraObj.projectId = id
            pacdoraObj.image3D = 'https:' + screenshot
          }
        } catch (error) {
          console.error('Error getting project ID in fetch interceptor:', error)
        }
        if (options.body instanceof FormData) {
          options.body.append('properties[pacdora-project-id]', pacdoraObj.projectId)
          options.body.append('properties[pacdora-image3D]', pacdoraObj.image3D)
        } else if (typeof options.body === 'string') {
          try {
            const bodyObj = JSON.parse(options.body)
            if (!bodyObj.properties) bodyObj.properties = {}
            bodyObj.properties['pacdora-project-id'] = pacdoraObj.projectId
            bodyObj.properties['pacdora-image3D'] = pacdoraObj.image3D
            options.body = JSON.stringify(bodyObj)
          } catch (e) {
            try {
              const bodyParams = new URLSearchParams(options.body)
              bodyParams.append('properties[pacdora-project-id]', pacdoraObj.projectId)
              bodyParams.append('properties[pacdora-image3D]', pacdoraObj.image3D)
              options.body = bodyParams.toString()
            } catch (urlError) {}
          }
        }
      }
      return window.originalFetch.apply(this, arguments)
    }
  }
}

function getSelectedVariant() {
  let form_selector = window.PRODUCT_DATA.form_selector
  if (!form_selector) return null
  const form = pacdoraUtils.safeQuerySelector(form_selector)
  if (!form) return null
  const selects = pacdoraUtils.safeQuerySelectorAll('select', form)
  if (selects.length === 0) return null
  const selectedOptions = []
  selects.forEach((select) => {
    selectedOptions.push(select.options[select.selectedIndex].value)
  })
  const variant = window.PRODUCT_DATA.variants.find((v) => {
    const variantOptions = v.options.map((opt) => opt.name)
    return (
      selectedOptions.length === variantOptions.length &&
      selectedOptions.every((option, index) => option == variantOptions[index])
    )
  })
  return variant
}

function listenToFormSelectors() {
  const form_selector = window.PRODUCT_DATA.form_selector
  if (!form_selector) return
  document.addEventListener('change', function (e) {
    const path = pacdoraUtils.getEventPath(e)
    if (!path || path.length === 0) return
    if (e.target.tagName === 'SELECT') {
      let isInTargetForm = false
      for (let i = 0; i < path.length; i++) {
        if (path[i].nodeType === 1 && path[i].matches && path[i].matches(form_selector)) {
          isInTargetForm = true
          break
        }
      }
      if (isInTargetForm) {
        const updatedVariant = getSelectedVariant()
        if (!updatedVariant) return
        if (lastVariant?.metafields && updatedVariant?.metafields) {
          const lastKeys = Object.keys(lastVariant.metafields)
          const updatedKeys = Object.keys(updatedVariant.metafields)
          if (
            lastKeys.length === updatedKeys.length &&
            lastKeys.every((key) => updatedVariant.metafields.hasOwnProperty(key) && lastVariant.metafields[key] === updatedVariant.metafields[key])
          ) { return }
        }
        updatePacdoraWithVariant(updatedVariant)
      }
    }
  })
}

async function updatePacdoraWithVariant(variant) {
  if (window.Pacdora) {
    try {
      lastVariant = variant
      let useType = ''
      if (variant.metafields.modelId) useType = 'model'
      else if (variant.metafields.templateId) useType = 'template'
      
      if (useType && currentModelOrTemplate !== variant.metafields.modelId && currentModelOrTemplate !== variant.metafields.templateId) {
        const loadingDiv = pacdoraUtils.safeQuerySelector('.pacdora-box-loading')
        if (loadingDiv) loadingDiv.style.display = 'block'
        await createPacdoraScene(useType, variant)
        if (loadingDiv) loadingDiv.style.display = 'none'
        return
      }
      let updateFlag = false
      if (variant.metafields.material && variant.metafields.material.trim() !== '') {
        await Pacdora.setMaterial({ name: variant.name, image: variant.metafields.material, async: false })
        updateFlag = true
      }
      let size = variant.metafields.size
      if (size) {
        const dimensions = size.toLowerCase().replace(/[x*]/g, '*').split('*').map((str) => str.trim()).map(Number).filter((num) => !isNaN(num))
        if (dimensions.length === 3) {
          const [length, width, height] = dimensions
          await Pacdora.setSize({ length, width, height, async: false })
        }
        updateFlag = true
      }
      if (updateFlag) await Pacdora.update()
    } catch (error) {
      console.error('Error updating Pacdora:', error)
    }
  }
}

var MAX_RETRIES = 3
async function loadPacdoraScriptWithRetry(retries = 0) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://cdn.pacdora.com/Pacdora-v${window.PACDORA_CONFIG.PacdoraVersion}.js`
    script.async = true
    script.onload = () => {
      if (window.Pacdora) resolve()
      else if (retries < MAX_RETRIES) loadPacdoraScriptWithRetry(retries + 1).then(resolve).catch(reject)
      else reject(new Error('Pacdora script load failed'))
    }
    script.onerror = () => {
      if (retries < MAX_RETRIES) loadPacdoraScriptWithRetry(retries + 1).then(resolve).catch(reject)
      else reject(new Error('Pacdora script load failed'))
    }
    document.body.appendChild(script)
  })
}

var createPacdora = async () => {
  interceptCart()
  const selectedVariant = window.PRODUCT_DATA.current_variant_id
  const variantData = window.PRODUCT_DATA.variants.find((v) => v.id == selectedVariant)
  lastVariant = variantData
  const modelId = variantData.metafields.modelId ? variantData.metafields.modelId : window.PRODUCT_DATA.pacdora_model_id
  const templateId = variantData.metafields.templateId ? variantData.metafields.templateId : window.PRODUCT_DATA.pacdora_template_id
  
  if (!modelId && !templateId) {
    showMessage('No model or template id found')
    return
  }
  let useType = 'model'
  if (variantData.metafields.modelId) useType = 'model'
  else if (variantData.metafields.templateId) useType = 'template'
  else if (window.PRODUCT_DATA.pacdora_model_id) useType = 'model'
  else if (window.PRODUCT_DATA.pacdora_template_id) useType = 'template'
  
  const appId = window.PACDORA_CONFIG.appId
  if (!appId) {
    showMessage('No app id found')
    return
  }
  createPacdora3d()
  await loadPacdoraScriptWithRetry()
  if (window.Pacdora) {
    Pacdora = window.Pacdora
    if (typeof Pacdora !== 'undefined') {
      await Pacdora.init({
        appId: appId,
        isDelay: true,
        isMobile: false,
        quotation: window.PACDORA_CONFIG.quotationOpen,
        customDefault: false,
        theme: '#333333'
      })
      await createPacdoraScene(useType, variantData, modelId, templateId)
      if (Pacdora.project?.value?.cate?.complex_type === 0) {
        const controlDiv = pacdoraUtils.safeQuerySelector('.pacdora-collapse-control')
        if (controlDiv) controlDiv.style.display = ''
      }
      Pacdora.$on('3d:init', () => {
        pacdoraUtils.safeQuerySelectorAll('.pacdora-box-loading').forEach((item) => item.style.display = 'none')
        const skeletonSelects = pacdoraUtils.safeQuerySelector('.pacdora-skeleton-selects')
        const selectorContent = pacdoraUtils.safeQuerySelector('.pacdora-selector-content')
        if (skeletonSelects) skeletonSelects.style.display = 'none'
        if (selectorContent) selectorContent.style.display = 'block'
        const selectContent = document.querySelector('.pacdora-selector-content')
        if (selectContent) selectContent.style.minHeight = '0px'
        const selectorBox = document.querySelector('.pacdora-selector-box')
        if (selectorBox) {
          selectorBox.style.opacity = '1'
          selectorBox.style.height = 'fit-content'
        }
      
      })
      pacdoraUtils.safeQuerySelectorAll('.pac-loading').forEach((item) => item.style.display = 'none')
      
      const contactButton = pacdoraUtils.safeQuerySelector('#pacdora-contact-button')
      if (contactButton) {
        contactButton.addEventListener('click', async () => {
          Pacdora.openPlusContactDialog({
            visible: true,
            canCancel: true,
            confirm: (result) => console.log('confirm ===>', result),
          })
        })
        contactButton.style.backgroundColor = '#000'
        contactButton.style.color = '#fff'
        contactButton.style.cursor = 'pointer'
      }
      Pacdora.$on('contact-dialog:loading', () => {
        const loadingEle = contactButton.querySelector('.pac-loading')
        if (loadingEle) loadingEle.style.display = 'block'
      })
      Pacdora.$on('contact-dialog:complete', () => {
        const loadingEle = contactButton.querySelector('.pac-loading')
        if (loadingEle) loadingEle.style.display = 'none'
      })
      const buyButton = pacdoraUtils.safeQuerySelector('#pacdora-buy-button')
      if (buyButton) {
        buyButton.addEventListener('click', async () => {
          await createShopifyOrder()
        })
        buyButton.style.backgroundColor = '#000'
        buyButton.style.color = '#fff'
        buyButton.style.cursor = 'pointer'
      }
      const designButton = pacdoraUtils.safeQuerySelector('#pacdora-advanced-design')
      mobileBtnEventHijacking(designButton)
      if (designButton) {
        designButton.addEventListener('click', () => {
          const loadingEle = designButton.querySelector('.pac-loading')
          if (loadingEle) loadingEle.style.display = 'block'
        })
      }
     
      
      Pacdora.$on('download:start', () => {
        const downloadEle = pacdoraUtils.safeQuerySelector('#pacdora-download')
        if (downloadEle) {
          downloadEle.style.cursor = 'not-allowed'
          const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
          const textEle = downloadEle.querySelector('.pac-text')
          if (textEle) textEle.innerText = 'Downloading...'
          if (downloadLoadingEle) downloadLoadingEle.style.display = 'block'
        }
      })
      Pacdora.$on('download:success', () => {
        const downloadEle = pacdoraUtils.safeQuerySelector('#pacdora-download')
        if (downloadEle) {
          downloadEle.style.cursor = 'pointer'
          const textEle = downloadEle.querySelector('.pac-text')
          if (textEle) {
            textEle.innerText = 'Download success'
            setTimeout(() => { textEle.innerText = 'Download Dieline' }, 1000)
          }
          const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
          if (downloadLoadingEle) downloadLoadingEle.style.display = 'none'
        }
      })
      Pacdora.$on('download:fail', () => {
        const downloadEle = pacdoraUtils.safeQuerySelector('#pacdora-download')
        if (downloadEle) {
          downloadEle.innerText = 'Download failed'
          setTimeout(() => { downloadEle.innerText = 'Download Dieline' }, 1000)
          const downloadLoadingEle = downloadEle.querySelector('.pac-loading')
          if (downloadLoadingEle) downloadLoadingEle.style.display = 'none'
        }
      })
      Pacdora.$on('design:opened', () => {
        const loadingEle = pacdoraUtils.safeQuerySelector('#pacdora-advanced-design .pac-loading')
        if (loadingEle) loadingEle.style.display = 'none'
        const shopifyFixed = pacdoraUtils.safeQuerySelector('#PBarNextFrameWrapper')
        if (shopifyFixed) shopifyFixed.style.display = 'none'
        document.body.style.overflow = 'hidden'
        document.body.style.position = 'fixed'
        document.body.style.width = '100%'
        document.body.style.top = `-${window.scrollY}px`
      })
      Pacdora.$on('advancedDesign:closed', () => {
        document.body.style.overflow = ''
        document.body.style.position = ''
      })
      Pacdora.$on('design:save', async (data) => {
        if (data.type === 'buyNow') {
          await createShopifyOrder()
          return false
        }
      })
    }
  }
}

// -------------------------------------------------------------
// HELPER: Setup "Apply" Button Logic
// -------------------------------------------------------------



function setupCouponApply() {
  const applyBtn = document.getElementById('PacdoraDiscountApply');
  const msg = document.getElementById('PacdoraDiscountMsg');
  const input = document.getElementById('PacdoraDiscount');
  const quickBtn = document.getElementById('quick-apply-btn');

  if (!applyBtn || !msg || !input) return;

  // 1. Function to reset Quick Apply button to default state
  const resetQuickBtn = () => {
    if (quickBtn) {
      quickBtn.innerText = "Click for Immediate 26% Discount";
      quickBtn.style.background = "#f4f4f4";
      quickBtn.style.color = "#000";
      quickBtn.style.borderColor = "#000";
      quickBtn.style.opacity = "1";
      quickBtn.style.pointerEvents = "auto";
    }
  };

  // 2. Main Apply Button Logic
  applyBtn.addEventListener('click', function() {
    const code = input.value.trim().toLowerCase();
    
    // If text box is empty, treat as "Remove Coupon"
    if (code === "") {
      msg.style.color = '#666';
      msg.innerHTML = 'Coupon removed. Code will be validated at checkout.';
      resetQuickBtn();
      return;
    }

    if (VALID_DISCOUNTS.hasOwnProperty(code)) {
      let display = VALID_DISCOUNTS[code] >= 1 
        ? `₹${VALID_DISCOUNTS[code]} OFF` 
        : `${(VALID_DISCOUNTS[code] * 100).toFixed(0)}% OFF`;
      
      msg.style.color = 'green';
      msg.innerHTML = `<strong>Code Applied!</strong> ${display} will be deducted at checkout.`;
      
      // Update Quick Apply button if the code matches
      if (quickBtn && code === quickBtn.getAttribute('data-coupon').toLowerCase()) {
        quickBtn.innerText = "Applied!";
        quickBtn.style.background = "#e6fffa";
        quickBtn.style.color = "#28a745";
        quickBtn.style.borderColor = "#28a745";
      }
    } else {
      msg.style.color = 'red';
      msg.innerHTML = 'Invalid or expired code.';
      resetQuickBtn(); // Reset button if an invalid code is typed
    }
  });

  // 3. Monitor input for "Live Reset"
  input.addEventListener('input', function() {
    const code = this.value.trim().toLowerCase();
    const targetCode = quickBtn ? quickBtn.getAttribute('data-coupon').toLowerCase() : '';

    // If the input no longer matches the Quick Apply code, reset the button
    if (code !== targetCode) {
      resetQuickBtn();
    }
    
    // If box is totally empty, reset message
    if (code === "") {
      msg.style.color = '#666';
      msg.innerHTML = 'Code will be validated at checkout.';
    }
  });

  // 4. Quick Apply Button Click
  if (quickBtn) {
    quickBtn.addEventListener('click', function() {
      input.value = this.getAttribute('data-coupon');
      applyBtn.click();
    });
  }
}

// -------------------------------------------------------------
// UPDATED FUNCTION: createShopifyOrder
// Calculates Discount Manually
// -------------------------------------------------------------
async function createShopifyOrder() {
  let buyLoading = pacdoraUtils.safeQuerySelector('#pacdora-buy-button .pac-loading');
  if (!buyLoading) {
      buyLoading = pacdoraUtils.safeQuerySelector('#pacdora-advanced-design .pac-loading');
  }
  
  if (buyLoading) buyLoading.style.display = 'block'
  
  try {
      await Pacdora._waitProjectCreate()
      await Pacdora.priceReady()

      let unitPrice = 0
      let quantity = 1
      const variantAttributes = []
      const data = Pacdora.getAdvancedData()
      const quantityData = Pacdora.getQuantityData()

      if (data) {
        data.forEach((item) => {
          if (!["Area", "Print", "image3D"].includes(item.type)) {
            variantAttributes.push({
              key: item.type,
              value: item.selectedName
            });
          }
        });
      }

      if (quantityData) {
        unitPrice = quantityData.options.find((item) => item.quantity === quantityData.quantity)?.unit_price || quantityData.price / quantityData.quantity || 0
        quantity = quantityData.quantity || 1
      }
      
      const { screenshot, id } = await Pacdora.getBoxInfo()
      variantAttributes.push({ key: 'projectId', value: id.toString() })

      // --- START: APPLY DISCOUNT LOGIC ---
      const discountInput = document.getElementById('PacdoraDiscount');
      let finalPrice = unitPrice;
      
      if (discountInput && discountInput.value.trim() !== '') {
          const code = discountInput.value.trim().toLowerCase();
          
          if (VALID_DISCOUNTS.hasOwnProperty(code)) {
              const discountValue = VALID_DISCOUNTS[code];
              let discountDisplay = "";

              if (discountValue > 1) {
                  // FLAT AMOUNT: Distribute $50 across the quantity
                  // e.g., 5 items, $50 off total -> $10 off per item
                  const perUnitDiscount = discountValue / quantity;
                  finalPrice = Math.max(0, unitPrice - perUnitDiscount);
                  discountDisplay = `₹${discountValue} Off Order`;
              } else {
                  // PERCENTAGE
                  finalPrice = unitPrice * (1 - discountValue);
                  discountDisplay = `${discountValue * 100}% Off`;
              }

              // --- ADDING ORIGINAL PRICE ATTRIBUTES ---
              // 1. Original Unit Price (Use "Original Unit Price" for clarity)
              variantAttributes.push({
                  key: 'Original Unit Price',
                  value: `${unitPrice.toFixed(2)}`
              });

              // 2. Original Order Total (Quantity * Original Unit)
              const originalTotal = (unitPrice * quantity).toFixed(2);
              variantAttributes.push({
                  key: 'Original Subtotal',
                  value: `${originalTotal}`
              });
              
              // 3. Discount Info
              variantAttributes.push({
                  key: 'Discount Code',
                  value: code.toUpperCase()
              });
              
              variantAttributes.push({
                  key: 'Discount Applied',
                  value: discountDisplay
              });
          }
      }
      // --- END ---

      const postData = {
        variantId: window.PRODUCT_DATA.current_variant_id.toString(),
        unitPrice: Number(finalPrice.toFixed(2)), // Force 2 decimals
        quantity: quantity,
        variantAttributes: variantAttributes
      }

      let response = await fetch(
          'https://api.pacdora.com/open/v1/shopify/order',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + localStorage.getItem('api-token'),
            },
            body: JSON.stringify(postData)
          }
        )
        let res = await response.json()
        if (res.code === 200) {
          
          let redirectUrl = res.data.url;
          window.location.href = redirectUrl

        } else {
          showMessage('Create order failed')
        }

  } catch (err) {
    console.error('createShopifyOrder error:', err)
    showMessage('Create order failed: ' + err.message, 'error')
  } finally {
    if (buyLoading) buyLoading.style.display = 'none'
  }
}


// Logic for the Quick Apply Button
function setupQuickApply() {
  const quickBtn = document.getElementById('quick-apply-btn');
  const input = document.getElementById('PacdoraDiscount');
  const applyBtn = document.getElementById('PacdoraDiscountApply');

  if (quickBtn && input && applyBtn) {
    quickBtn.addEventListener('click', function() {
      const code = this.getAttribute('data-coupon');
      input.value = code; // Fill the box
      applyBtn.click();   // Trigger the existing Apply logic
    });
  }
}

async function initPacdora() {
  document.addEventListener('DOMContentLoaded', async () => {
   
    await createPacdora()
    listenToFormSelectors()
    setupCouponApply()
    setupQuickApply()
    // --- TEST BLOCK START ---
    const bulkBtn = document.getElementById('bulk-order-trigger');
    if (bulkBtn) {
      console.log('Bulk Order button found in DOM'); // Check Console for this
      bulkBtn.addEventListener('click', function(e) {
        e.preventDefault();
        //console.log('Bulk Order button was CLICKED'); // Check Console for this
        //alert('Button Event is Working!'); // This will show a popup on your screen
        
        if (typeof window.openBulkOrderModal === 'function') {
          window.openBulkOrderModal(1000);
        } else {
          console.error('Function window.openBulkOrderModal is missing!');
        }
      });
    } else {
      console.error('Bulk Order button NOT found in DOM. Check ID in pacdora-design.liquid');
    }
    // --- TEST BLOCK END ---
  })
}
function onSwitch2DAnd3D(type, event) {
  event?.stopPropagation()
  event?.preventDefault()
  const switchItems = pacdoraUtils.safeQuerySelectorAll('.pacdora-switch-item')
  const boxInfo = pacdoraUtils.safeQuerySelector('.pacdora-box-info-slider')
  if (type === '3d') {
    switchItems[0].className = 'pacdora-switch-item active'
    switchItems[1].className = 'pacdora-switch-item'
    boxInfo.style.transform = 'translateX(0)'
  } else if (type === 'dieline') {
    switchItems[0].className = 'pacdora-switch-item'
    switchItems[1].className = 'pacdora-switch-item active'
    boxInfo.style.transform = 'translateX(-100%)'
  }
}
function openPacdora(ratio) {
  if (window.Pacdora) window.Pacdora.collapse('d3', ratio)
  const pointer = pacdoraUtils.safeQuerySelector('.pacdora-pointer')
  if (pointer) pointer.style.left = `${ratio * 100}%`
  const selected = pacdoraUtils.safeQuerySelector('.pacdora-slider-selecter')
  if (selected) selected.style.width = `${ratio * 100}%`
}
function onSliderDown(e) {
  const parentBounding = e.parentNode.getBoundingClientRect()
  document.onpointermove = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()
    const { clientX } = ev
    const len = clientX - parentBounding.left
    let ratio = len / parentBounding.width
    if (ratio < 0) ratio = 0
    if (ratio > 1) ratio = 1
    window.Pacdora.collapse('d3', ratio)
    e.style.left = `${ratio * 100}%`
    const selected = e.parentNode.querySelector('.pacdora-slider-selecter')
    selected.style.width = `${ratio * 100}%`
  }
  document.onpointerup = (ev) => {
    ev.stopPropagation()
    ev.preventDefault()
    document.onpointermove = null
    document.onpointerup = null
  }
}
function onSetSlider(e) {
  e.stopPropagation()
  e.preventDefault()
  const parentBounding = e.target.parentNode.getBoundingClientRect()
  const len = e.clientX - parentBounding.left
  let ratio = len / parentBounding.width
  if (ratio < 0) ratio = 0
  if (ratio > 1) ratio = 1
  openPacdora(ratio)
}
function showMessage(message, type) {
  Pac_Shopify_Message.message({ type: type, message })
}
if (!window.pacdoraSectionLoadHandler) {
  window.pacdoraSectionLoadHandler = async (event) => { await createPacdora() }
}
document.removeEventListener('shopify:section:load', window.pacdoraSectionLoadHandler)
document.addEventListener('shopify:section:load', window.pacdoraSectionLoadHandler)

async function createPacdoraScene(useType, variantData, modelId, templateId) {
  const dimension = { width: undefined, height: undefined, length: undefined }
  const materialSetting = { materialName: undefined, materialImage: undefined }
  if (variantData.metafields.material) {
    materialSetting.materialId = 44
    materialSetting.materialName = variantData.name
    materialSetting.materialImage = variantData.metafields.material
  }
  let size = variantData.metafields.size
  if (size) {
    const dimensions = size.toLowerCase().replace(/[x*]/g, '*').split('*').map((str) => str.trim()).map(Number).filter((num) => !isNaN(num))
    if (dimensions.length === 3) {
      const [length, width, height] = dimensions
      dimension.length = length
      dimension.width = width
      dimension.height = height
    }
  }
  if (!useType || !variantData) { return null }
  const packagingColors = ['#ff0000', '#00ff00', '#0000ff', '#893829']
  let sceneParams = { doneBtn: 'Save', packagingColors }
  if (!window.PACDORA_CONFIG.quotationOpen) {
    sceneParams.advancedSetting = { ...materialSetting, width: dimension.width, height: dimension.height, length: dimension.length }
  }
  if (useType === 'model' && variantData.metafields.modelId) 
    {
              sceneParams.modelId = variantData.metafields.modelId;
              if (sceneParams.modelId === '602581') 
                {
                    // Assigning the clip configuration to sceneParams
                    sceneParams.clips = {
                      outside: [
                        {
                        x: 20,
                        y: 46,
                        w: 600,
                        h: 365,
                        }
                      ]
                    };
                 }                
             
  }
  else if (useType === 'template' && variantData.metafields.templateId) sceneParams.templateId = variantData.metafields.templateId
  else if (useType === 'model' && modelId) 
    {
      sceneParams.modelId = modelId;

  /*if (modelId === '602581') {
    // Assigning the clip configuration to sceneParams
    /*sceneParams.clips = {
      outside: [
        {
          x: 29.565,
          y: 83.383,
          w: 54.755,
          h: 39.314,
        }
      ]
    };
  }*/
}
  else if (useType === 'template' && templateId) sceneParams.templateId = templateId
  else { return null }
  try {
    currentModelOrTemplate = sceneParams.modelId || sceneParams.templateId
    const id = await Pacdora.createScene(sceneParams)
    return id
  } catch (err) {
    console.error('Error creating scene:', err)
    const loadingDiv = pacdoraUtils.safeQuerySelector('.pacdora-box-loading')
    if (loadingDiv) loadingDiv.style.display = 'none'
    return null
  }
}
function mobileBtnEventHijacking(dom) {
  /*if (Pacdora_isMobile) {
    dom.addEventListener('click', (e) => {
      showMessage('Please Use Desktop for the Best Experience.', 'warn')
      e.stopPropagation()
      e.preventDefault()
    }, { capture: true })
  }*/
 return;
}
class Pac_Shopify_Message {
  static message({ type, message }) {
    let messageBox = pacdoraUtils.safeQuerySelector('.message-box')
    if (!messageBox) {
      messageBox = document.createElement('div')
      messageBox.className = 'message-box'
      Object.assign(messageBox.style, {
        position: 'fixed', top: '32px', left: 0, right: 0, margin: 'auto', zIndex: 1999000000, textAlign: 'center'
      })
      document.body.appendChild(messageBox)
    }
    const div = document.createElement('div')
    div.style.marginBottom = '24px'
    const messageItem = document.createElement('div')
    div.appendChild(messageItem)
    Object.assign(messageItem.style, {
      height: '48px', background: '#ffffff', borderRadius: '24px', boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.12)',
      display: 'inline-block', fontSize: '12px', fontWeight: 400, lineHeight: '48px', padding: '0 20px', animation: 'message-in 0.5s'
    })
    let img = ``
    if (type === 'success') img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/success.png"/>`
    else if (type === 'warn') img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/warn.png"/>`
    else if (type === 'error') img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/error.png"/>`
    messageItem.innerHTML = `${img} ${message}`
    messageBox.appendChild(div)
    setTimeout(() => { messageBox?.removeChild(div) }, 2000)
  }
  static success(message) { this.message({ type: 'success', message }) }
  static warn(message) { this.message({ type: 'warn', message }) }
  static error(message) { this.message({ type: 'error', message }) }
}